import type {
  GameBookImportReceipt,
  GameBookImportRequest,
} from "../../../../shared/contracts/gamebook-import.js";

/** The server confirmed this request has no committed receipt, not that no similar round exists. */
export class GameBookImportRejected extends Error {
  constructor(
    public readonly requestId: string,
    message: string,
  ) {
    super(message);
  }
}

export async function postGameBookImport(
  request: GameBookImportRequest,
): Promise<GameBookImportReceipt> {
  const response = await fetch("/api/v1/round-imports/gamebook", {
    method: "POST",
    credentials: "include",
    headers: { accept: "application/json", "content-type": "application/json" },
    body: JSON.stringify(request),
  });
  if (response.ok) return response.json() as Promise<GameBookImportReceipt>;
  const body = (await response.json().catch(() => null)) as {
    type?: unknown;
    detail?: unknown;
    requestId?: unknown;
    requestRejected?: unknown;
  } | null;
  const message =
    typeof body?.detail === "string"
      ? body.detail
      : "The import could not be confirmed. Continue the saved import.";
  if (
    [400, 403, 404, 409].includes(response.status) &&
    body?.type === "https://fairwayrivalry.com/problems/gamebook-import" &&
    body.requestId === request.requestId &&
    body.requestRejected === true
  )
    throw new GameBookImportRejected(request.requestId, message);
  throw new Error(message);
}
